/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_List_Mail_ComposeInputs */

const en_admin_user_list_mail_compose = /** @type {(inputs: Admin_User_List_Mail_ComposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compose email`)
};

const de_admin_user_list_mail_compose = /** @type {(inputs: Admin_User_List_Mail_ComposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail schreiben`)
};

/**
* | output |
* | --- |
* | "Compose email" |
*
* @param {Admin_User_List_Mail_ComposeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_list_mail_compose = /** @type {((inputs?: Admin_User_List_Mail_ComposeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_List_Mail_ComposeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_list_mail_compose(inputs)
	return en_admin_user_list_mail_compose(inputs)
});